import { useNavigate, useParams } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import useAuthModal from '../hooks/useAuthModal';
import JobDetailsContent from '../components/JobDetailsContent';
import Footer from '../components/Footer';
import { useState } from 'react';
import { canStartInterview } from '../utils/interviewEligibility';
import SubscriptionLimitModal from '../components/SubscriptionLimitModal';

export default function JobDetailsScreen() {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const authModal = useAuthModal();
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [limitErrorMessage, setLimitErrorMessage] = useState('');
  const [startingInterview, setStartingInterview] = useState(false);

  const handleStartInterview = async () => {
    if (startingInterview) return;
    setStartingInterview(true);
    try {
      const check = await canStartInterview();
      if (check.unauthorized) {
        authModal.openAuth('search');
        return;
      }
      if (!check.ok) {
        setLimitErrorMessage(check.message || '');
        setShowLimitModal(true);
        return;
      }
      navigate(`/chat-setting/${jobId}`);
    } finally {
      setStartingInterview(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F7FB] text-[#1E293B]">
      <SiteHeader authModal={authModal} />

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="md:hidden mb-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-sm text-gray-600"
          >
            Back
          </button>
        </div>
        <JobDetailsContent
          jobId={jobId}
          showStartButton={false}
          onStartInterview={handleStartInterview}
        />
      </main>

      <div className="hidden md:block">
        <Footer />
      </div>
      <div className="h-28" />

      <footer className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="text-sm text-gray-500">45 people applied</div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={handleStartInterview}
              disabled={startingInterview}
              className="btn-orange px-5 py-2 text-sm rounded-2xl shadow-lg shadow-orange-500/20"
            >
              {startingInterview ? 'Checking access...' : 'Start AI Interview'}
            </button>
          </div>
        </div>
      </footer>

      <SubscriptionLimitModal
        isOpen={showLimitModal}
        onClose={() => setShowLimitModal(false)}
        errorMessage={limitErrorMessage}
      />
    </div>
  );
}
